import React from 'react';
import { useIntl } from 'react-intl';
import { columnMessages, STAGE_BADGE_CLASSES, type BoardColumnKey } from '../../../utils/job-tracking/pipeline-stage-meta';
import { formatRelativeAge } from '../../../utils/dates/format-relative-age';
import { useFormatMessage } from '../../../i18n-review/client/Msg';

export interface PipelineStageChipProps {
  stage: BoardColumnKey;
  /** ISO timestamp — when present, appended as "· 5 days ago" (same relative-age format as saved searches). */
  appliedAt?: string;
}

/**
 * "Applied · 5 days ago" / "Saved" pill on SRP cards — search results know your pipeline
 * (SEEKER_HUB_PLAN.md P3 item 1). Same taxonomy, labels, and colors as the My Jobs kanban
 * (columnMessages/STAGE_BADGE_CLASSES) so the two surfaces never disagree.
 */
export const PipelineStageChip: React.FC<PipelineStageChipProps> = ({ stage, appliedAt }) => {
  const intl = useIntl();
  const formatMessage = useFormatMessage();
  const label = formatMessage(columnMessages[stage]);
  const age = appliedAt ? formatRelativeAge(intl.locale, Date.now(), Date.parse(appliedAt)) : '';

  return (
    <span
      className={`inline-flex items-center gap-1 self-start rounded-full border px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap ${STAGE_BADGE_CLASSES[stage]}`}
    >
      {age ? `${label} · ${age}` : label}
    </span>
  );
};
